export const createCircleIconSVG = (hexColor) => {
  // Create the SVG element
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 48 48');
  svg.setAttribute('width', '48');
  svg.setAttribute('height', '48');

  // Create the outer circle
  const circleOuter = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circleOuter.setAttribute('cx', '24');
  circleOuter.setAttribute('cy', '24');
  circleOuter.setAttribute('r', '22.5');
  circleOuter.setAttribute('fill', hexColor);
  circleOuter.setAttribute('stroke', '#fff');
  circleOuter.setAttribute('stroke-width', '3');

  // Create the inner circle
  const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  group.setAttribute('transform', 'translate(24, 24)');

  const circleInner = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circleInner.setAttribute('r', '10');
  circleInner.setAttribute('fill', '#fff');

  // Add the elements to the SVG element
  group.appendChild(circleInner);
  svg.appendChild(circleOuter);
  svg.appendChild(group);

  return svg;
};
